import { css } from '@emotion/css';

export const listItemStyles = css`
  .item-container > .border-container {
    border: 1px solid var(--divider);
    border-top: none;
  }
  .item-container:first-child > .border-container {
    border-top: 1px solid var(--divider);
    border-top-left-radius: 0.8rem;
    border-top-right-radius: 0.8rem;
  }
  .item-container:last-child > .border-container {
    border-bottom-left-radius: 0.8rem;
    border-bottom-right-radius: 0.8rem;
  }
`;
